import { Box, Popover, ThemeProvider, Typography } from "@material-ui/core";
import { InsightsIcon } from "../../Icons/InsightsIcon";
import React from "react";
import { groopTheme } from "../../styles/MaterialGroopTheme";

interface TextOrUrlClickedPopoverProps {
  anchorEl: HTMLElement | null;
  // eslint-disable-next-line @typescript-eslint/ban-types
  clickAwayHandler: (event: {}) => void;
  processClipboardContents: (text: string, source: string) => void;
  source: string;
}

export const TextOrUrlClickedPopover = (
  props: TextOrUrlClickedPopoverProps,
) => {
  const handleOnUseClipboardContents = async () => {
    const clipboardText = await navigator.clipboard.readText();
    props.processClipboardContents(clipboardText, props.source);
  };

  return (
    <Popover
      anchorOrigin={{
        horizontal: "right",
        vertical: "top",
      }}
      transformOrigin={{
        horizontal: "left",
        vertical: "top",
      }}
      PaperProps={{
        style: {
          borderRadius: 6,
          padding: "1px 8px",
        },
      }}
      anchorEl={props.anchorEl}
      open={props.anchorEl != null}
      onClose={(event) => props.clickAwayHandler(event)}
    >
      <ThemeProvider theme={groopTheme}>
        <Typography component="span">
          <Box color="primary.dark" className="italic text-sm">
            Highlight source {props.source}. Ctrl-C to copy. Click{" "}
            <InsightsIcon onClick={handleOnUseClipboardContents} />.
          </Box>
        </Typography>
      </ThemeProvider>
    </Popover>
  );
};
